import { saveAs } from "file-saver";

/**
 * Downloads a file from a URL using file-saver
 * @param url - The URL of the file to download
 * @param filename - Optional filename for the downloaded file. If not provided, it will be extracted from the URL
 */
export const downloadFile = async (url: string, filename?: string): Promise<void> => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch file: ${response.status}`);
    }
    const blob = await response.blob();
    const resolvedFilename = filename || url.split("/").pop() || "download";
    saveAs(blob, resolvedFilename);
  } catch (error) {
    console.error("Failed to download file:", error);
    throw error;
  }
};
